<template>
  <div />
</template>

<script>
export default {
  name: 'KeyboardListener',

  props: {
    keycodeStart: {
      type: Number,
      required: true
    },
    keycodeEnd: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    input: {
      activated: false,
      value: ''
    }
  }),

  mounted () {
    document.addEventListener('keyup', this.keyUpListener)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyUpListener)
  },

  methods: {
    activate () {
      this.$set(this.input, 'activated', true)
    },
    deactivate () {
      this.$set(this.input, 'activated', false)
    },
    keyUpListener (event) {
      switch (event.which) {
        case this.keycodeStart:
          this.activate()
          this.$set(this.input, 'value', '')
          this.$emit('started')
          break
        case this.keycodeEnd:
          if (!this.input.activated) return false
          this.deactivate()
          this.$set(this.input, 'value', Number(this.input.value))
          this.$emit('ended', this.input.value)
          break
        default: /* any number */
          if (!this.input.activated) return false
          if (event.key && !isNaN(event.key)) {
            const value = this.input.value + event.key
            this.$set(this.input, 'value', value)
          }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/KeyboardListener.vue